import { useState, useEffect } from 'react'
import { AppData } from '../types'
import { getStoredData, saveStoredData, initialData } from '../utils/storage'

export function useLocalStorage() {
  const [data, setData] = useState<AppData>(initialData)
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    const stored = getStoredData()
    setData(stored)
    setIsLoaded(true)
  }, [])

  const updateData = (newData: Partial<AppData>) => {
    setData((prev) => {
      const updated = { ...prev, ...newData }
      saveStoredData(updated)
      return updated
    })
  }

  const addItem = <K extends keyof AppData>(key: K, item: any) => {
    setData((prev) => {
      if (!Array.isArray(prev[key])) return prev
      const updatedList = [item, ...(prev[key] as any[])]
      const updated = { ...prev, [key]: updatedList }
      saveStoredData(updated)
      return updated
    })
  }

  const updateItem = <K extends keyof AppData>(
    key: K,
    id: string,
    updates: any,
  ) => {
    setData((prev) => {
      if (!Array.isArray(prev[key])) return prev
      const updatedList = (prev[key] as any[]).map((item) =>
        item.id === id ? { ...item, ...updates } : item,
      )
      const updated = { ...prev, [key]: updatedList }
      saveStoredData(updated)
      return updated
    })
  }

  return { data, updateData, addItem, updateItem, isLoaded }
}
